var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 7.125H8.708c-.874 0-1.583.709-1.583 1.583v7.125c0 .875.709 1.584 1.583 1.584h7.125c.875 0 1.584-.71 1.584-1.584V8.708c0-.874-.71-1.583-1.584-1.583z",
    stroke: "#85BB65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96 11.875h-.79a1.583 1.583 0 0 1-1.584-1.583V3.167a1.583 1.583 0 0 1 1.583-1.584h7.125a1.584 1.584 0 0 1 1.584 1.584v.791",
    stroke: "#85BB65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgCopy;